module.exports = __webpack_public_path__ + "img/bg.319ceb68.jpg";